import React, { ReactNode } from "react";
import LayoutError from "@/src/views/layouts/error";
import { reportClientError } from "@/src/services/utils/clientErrorLogger";
import { captureError } from "@/src/lib/monitoring";

type ClientErrorBoundaryProps = {
  children: ReactNode;
};

type ClientErrorBoundaryState = {
  hasError: boolean;
};

class ClientErrorBoundary extends React.Component<
  ClientErrorBoundaryProps,
  ClientErrorBoundaryState
> {
  state: ClientErrorBoundaryState = {
    hasError: false,
  };

  static getDerivedStateFromError() {
    return {
      hasError: true,
    };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    reportClientError({
      type: "react.error-boundary",
      error,
      componentStack: errorInfo.componentStack || null,
    });

    captureError(error, {
      source: "ui-error",
      componentName: "ClientErrorBoundary",
      extra: { componentStack: errorInfo.componentStack },
    });
  }

  handleRetry = () => {
    this.setState({
      hasError: false,
    });
  };

  render() {
    if (this.state.hasError) {
      return <LayoutError onRetry={this.handleRetry} />;
    }

    return this.props.children;
  }
}

export default ClientErrorBoundary;
